import { createTheme, TypeBackground } from '@mui/material/styles';
import { PaletteColorOptions } from '@mui/material/styles/createPalette';

declare module '@mui/material/styles' {
  interface Palette { hoverColor?: PaletteColorOptions; }
  interface PaletteOptions { hoverColor?: PaletteColorOptions; }
  interface BreakpointOverrides {
    xs: true; sm: false; md: false; lg: false; xl: false; mobile: true; tablet: true; desktop: true;
  }
}

export const themeMUI = createTheme({
  breakpoints: { values: { xs: 0, mobile: 360, tablet: 768, desktop: 1280 } },
  palette: {
    mode: 'light',
    secondary: { main: 'rgba(111, 143, 91, 1)' },
    hoverColor: { main: 'rgba(201, 138, 61, 1)' },
    background: {
      paper: 'rgba(255, 255, 255, 1)',
      default: 'rgba(240, 239, 234, 1)',
      primary: 'rgba(23, 26, 29, 0.06)',
    } as Partial<TypeBackground>,
    text: { primary: 'rgba(23, 26, 29, 1)', disabled: 'rgba(115, 122, 128, 1)' },
    warning: { main: 'rgba(201, 138, 61, 1)' },
    error: { main: 'rgba(214, 69, 69, 1)' },
    success: { main: 'rgba(95, 117, 78, 1)' },
    primary: { main: 'rgba(111, 143, 91, 1)' },
  },
  typography: {
    fontFamily: 'Inter',
    fontSize: 20, htmlFontSize: 20,
    fontWeightLight: 300, fontWeightMedium: 500, fontWeightBold: 700,
    h2: { fontWeight: 700 },
  },
});
